import React, { useState } from 'react';

import { ILayoutProps } from '@/components/Layout';
import { BottomCard } from '@/components/shared/BottomCard/BottomCard';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';

import { SecondStep } from '../../../GenerateSettingsBottomPanel/SecondStep/SecondStep';

export interface ServiceChipPanelProps {
	initialServiceId?: string | null;
	initialStartDate?: string;
	initialStartTime?: string;
	onSave: (values: {
		serviceId: string | null | undefined;
		startDate: string;
		startTime: string;
	}) => void;
	onClose: () => void;
	setAccountOpen: ILayoutProps['setAccountOpen'];
}

export const ServiceChipPanel: React.FC<ServiceChipPanelProps> = ({
	initialServiceId,
	initialStartDate = '',
	initialStartTime = '',
	onSave,
	onClose,
	setAccountOpen,
}) => {
	const [startDate, setStartDate] = useState(initialStartDate);
	const [startTime, setStartTime] = useState(initialStartTime);
	const [selectedServiceId, setSelectedServiceId] = useState<
		string | null | undefined
	>(initialServiceId);

	const fireSaveService = useAnalyticsEvent('Generate_Setlist_Save_Service');

	return (
		<BottomCard
			title="Service"
			hasCloseButton={true}
			closeButtonLabel="Cancel"
			onClose={onClose}
		>
			<SecondStep
				startTime={startTime}
				startDate={startDate}
				setStartTime={setStartTime}
				setStartDate={setStartDate}
				setSelectedServiceId={setSelectedServiceId}
				selectedServiceId={selectedServiceId}
				onSave={() => {
					fireSaveService();
					onSave({ serviceId: selectedServiceId, startDate, startTime });
				}}
				setAccountOpen={setAccountOpen}
			/>
		</BottomCard>
	);
};
